export { default } from './user-badge';
